import { render, staticRenderFns } from "./Install.vue?vue&type=template&id=3b2e352e&scoped=true&"
import script from "./Install.vue?vue&type=script&lang=js&"
export * from "./Install.vue?vue&type=script&lang=js&"
import style0 from "./Install.vue?vue&type=style&index=0&id=3b2e352e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2e352e",
  null
  
)

export default component.exports